<template>
  <Link
    :href="props.params.link"
    ref="linkRef"
    class="flex items-center gap-2 xl:gap-4 w-full px-3 xl:pl-8 text-inherit hover:text-inherit"
  >
    <CheckCheckIcon
      v-if="params.status === DELIVERY_STATUS.COMPLETE"
      size="24"
    />
    <CircleXIcon
      v-if="params.status === DELIVERY_STATUS.CANCELLED"
      size="24"
    />
    <ClockIcon
      v-if="params.status === DELIVERY_STATUS.PENDING"
      size="24"
    />
    <RadarIcon
      v-if="params.status === DELIVERY_STATUS.DISPATCHED"
      size="24"
    />
    <TruckIcon
      v-if="params.status === DELIVERY_STATUS.IN_TRANSIT"
      size="24"
    />
    <CalendarDaysIcon
      v-if="params.status === DELIVERY_STATUS.RESCHEDULED"
      class="w-6 h-6"
    />
    <CubeTransparentIcon
      v-if="params.status === DELIVERY_STATUS.READY"
      class="w-6 h-6"
    />
    <TriangleAlertIcon
      v-if="params.status === DELIVERY_STATUS.FAILED"
      size="24"
    />
    <span class="flex flex-col text-left">
      <span class="font-semibold capitalize">
        {{ params.label }}
      </span>
      <span class="text-xxs font-medium">
        {{ createdAt }}
      </span>
    </span>
  </Link>
</template>

<script setup>
import { ref } from 'vue'
import { DateTime } from 'luxon'
import { CalendarDaysIcon, CubeTransparentIcon } from '@heroicons-2/vue/24/outline'
import { Link } from '@inertiajs/vue3'
import { useStopPropagation } from '@/Composables/stop-propagation'

// Standard icons are imported here.
import { RadarIcon, TriangleAlertIcon, CheckCheckIcon, CircleXIcon, TruckIcon, ClockIcon } from 'lucide-vue-next'

// import { Icon } from 'lucide-vue-next'
// "Labs" icons are imported here and must be used with the Icon component.
// import { unicornHead } from '@lucide/lab'

import { DELIVERY_STATUS } from '@/Pages/Deliveries/constants'

const linkRef = ref(null)

// @Note: Prevents AG Grid from showing its custom right-click menu.
useStopPropagation({ linkRef })

/**
 * @typedef {Object} OrderStatusCellParams
 * @property {string} status - The order status
 * @property {Function} onClick - The function to call when the cell is clicked
 */
const props = defineProps({
  /** @type {OrderStatusCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const createdAtDateTime = DateTime.fromISO(props.params.data.created_at)

const createdAt = createdAtDateTime.toRelative({
  style: 'short'
})
</script>
